import { fork } from 'redux-saga/effects';

import * as assignmentPendingList from './assignment-pending-req';
import * as assignmentReviewedList from './assignment-reviewed-req';
import * as assignmentUpdate from './assignment-update-req';
import assignmentListPagination from './sagas/assignmentListPagination';
import resolveAssignments from './sagas/resolveAssignments';

export default function* dependentManagementRootSaga() {
  yield fork(assignmentPendingList.watcher);
  yield fork(assignmentPendingList.paginationWatcher);
  yield fork(assignmentReviewedList.watcher);
  yield fork(assignmentReviewedList.paginationWatcher);
  yield fork(assignmentUpdate.watcher);
  yield fork(assignmentListPagination);
  yield fork(resolveAssignments);
}



// WEBPACK FOOTER //
// ./src/redux/dependentManagement/root-saga.js